import type { FailCodeSectionEntity } from '../entities';

import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for fetching all top-level fail code sections for a vehicle configuration.
 */
export type FetchSectionsByVehicleParams = {
    /** The vehicle model code (e.g. "GUE"). */
    modelCode?: string;

    /** The vehicle model year (e.g. "2024"). */
    modelYear?: string;

    /** The vehicle option/trim code (e.g. "01"). */
    optionCode?: string;

    /** Optional abort signal for cancellation. */
    signal?: AbortSignal;
};

/**
 * Fetch all top-level fail code sections for a vehicle configuration.
 * Used by the lookup-by-section flow to populate the first-level dropdown.
 */
export class FetchSectionsByVehicle extends StsBackendOperation {
    /**
     * Fetch sections from the API and return them as domain entities.
     *
     * @param params - the vehicle identifiers and optional abort signal
     * @returns the sections as domain entities
     */
    async exec(params: FetchSectionsByVehicleParams): Promise<FailCodeSectionEntity[]> {
        const { signal, ...request } = params;
        const response = await this.client.fetchFailCodeSections(request, signal);

        if (!response.success) {
            return [];
        }

        return response.data.sections ?? [];
    }
}
